import { render, staticRenderFns } from "./commonPiker.vue?vue&type=template&id=63c8f2f0&scoped=true&"
import script from "./commonPiker.vue?vue&type=script&lang=js&"
export * from "./commonPiker.vue?vue&type=script&lang=js&"
import style0 from "./commonPiker.vue?vue&type=style&index=0&id=63c8f2f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c8f2f0",
  null
  
)

export default component.exports